import React, { useEffect, useState } from "react";
import { Alert, Box, Snackbar } from "@mui/material";
import UserTable from "../../components/UserTable";
import IndiaProviderProfileDialog from "../../components/india/IndiaProviderProfileDialog";
import { listIndiaProviders } from "../../utils/indiaAdminService";

/**
 * India "Provider" page: all India service providers in the same table as the
 * Australian Clients page; View opens the India profile dialog.
 */
const IndiaClients = () => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [viewClient, setViewClient] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const fetchClients = async () => {
    setLoading(true);
    setError("");
    try {
      const result = await listIndiaProviders("all");
      setClients(result.providers || []);
    } catch (err) {
      setError(`Failed to fetch service providers: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <UserTable users={clients} onView={setViewClient} loading={loading} />

      <IndiaProviderProfileDialog
        open={Boolean(viewClient)}
        providerId={viewClient?.id}
        providerName={viewClient?.name}
        onClose={() => setViewClient(null)}
        onStatusChanged={(id, approvalStatus) =>
          setClients((prev) => prev.map((c) => (c.id === id ? { ...c, approvalStatus } : c)))
        }
        notify={(message, severity = "success") => setSnackbar({ open: true, message, severity })}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default IndiaClients;
